// Central, config-driven site contact info. Change the number here (or via
// frontend/.env REACT_APP_PHONE_*) and every location updates automatically.
export const PHONE_DISPLAY = process.env.REACT_APP_PHONE_DISPLAY || "(216) 245-5967";
export const PHONE_TEL = process.env.REACT_APP_PHONE_TEL || "12162455967";
export const PHONE_E164 = process.env.REACT_APP_PHONE_E164 || "+1-216-245-5967";
